import { VaultDetailProvider } from 'context/vault-detail-context';
import { withAuth } from 'hocs/auth/with-auth';
import { AlbumViewMode } from './album-view-mode';

// Owner-facing, vault-scoped album screen (/vaults/:id/album/:albumId).
// Wrapped in VaultDetailProvider so the reused editing components
// (location menu, header tags, add-content) get their vault context.
const AlbumScreenInner = () => (
  <VaultDetailProvider>
    <AlbumViewMode />
  </VaultDetailProvider>
);

const AlbumScreen = withAuth(AlbumScreenInner);

export { AlbumScreen };
